import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { BsCalendar3 } from "react-icons/bs"
import { AiFillTag } from "react-icons/ai"

const NewsFeaturedText = () => {
  const { allStrapiArticle, allStrapiCategory } = useStaticQuery(graphql`
    {
      allStrapiArticle(filter: { isFeaturedText: { eq: true } }, limit: 1) {
        nodes {
          id
          slug
          title
          description
          subtitle
          date
        }
      }
      allStrapiCategory(filter: {articles: {elemMatch: {isFeaturedText: {eq: true}}}}) {
        nodes {
          slug
          name
        }
      }
    }
  `)

  const featuredHero = allStrapiArticle.nodes
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  return (
    <>
      <div className={`news-text conatiner-orange-no-padding`}>
        <div className="card-info">
          <div className="card-info-top">
            <BsCalendar3 className="date-icon" />
            <span>{new Date(featuredHero[0]?.date)?.toLocaleDateString(
                "es-MX",
                options
              )}</span>
            <AiFillTag className="tag-icon" />
            <span>{allStrapiCategory?.nodes[0]?.name}</span>
          </div>
          <Link to={`/blog/${featuredHero[0]?.slug}`}>
            <h2>{featuredHero[0]?.title}</h2>
            <p>{featuredHero[0]?.subtitle}</p>
          </Link>
        </div>
      </div>
    </>
  )
}

export default NewsFeaturedText
